import { QueryClient } from '@tanstack/react-query';
import { ApiRequestError } from '@/services/api';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        // Never retry an auth or permission failure — it will not change.
        if (error instanceof ApiRequestError) {
          if (error.isUnauthorized || error.isForbidden || error.isValidation) return false;
        }
        return failureCount < 2;
      },
    },
    mutations: { retry: false },
  },
});

export const queryKeys = {
  me: ['auth', 'me'] as const,
  units: ['business-units'] as const,
  periods: ['periods'] as const,
  kpis: (unitId: string, periodId?: string) => ['kpis', unitId, periodId ?? 'latest'] as const,
  pnl: (unitId: string, year: number) => ['pnl', unitId, year] as const,
  expenses: (unitId: string, periodId?: string) =>
    ['expenses', unitId, periodId ?? 'latest'] as const,
  company: (periodId?: string) => ['company', 'overview', periodId ?? 'latest'] as const,
  imports: ['imports'] as const,
  importDetail: (id: string) => ['imports', id] as const,
  importQuality: (id: string) => ['imports', id, 'quality'] as const,
  importChanges: (id: string) => ['imports', id, 'changes'] as const,
  importUnmapped: (id: string) => ['imports', id, 'unmapped'] as const,
  categories: ['categories'] as const,
};
